import Route from '@core/components/Route';
import Paragraph from '@shared/components/Paragraph';
import { Breakpoint } from '@shared/theme/type';
import { FC, memo } from 'react';

import { H1Gold } from '../../components/ColoredHeading';
import GenericLayout from '../../components/GenericLayout';
import ImpressumH3 from '../../components/ImpressumH3';
import NoPageImageSection from '../../components/NoPageImageSection';

const Impressum: FC = () => (
  <GenericLayout title='Impressum'>
    <NoPageImageSection maxW={Breakpoint.SM}>
      <H1Gold center position='static'>
        Impressum
      </H1Gold>

      <Paragraph center>
        Zander, Jäger GbR
        <br />
        Berliner Str. 11
        <br />
        c/o Eckhard Jäger
        <br />
        13187 Berlin
      </Paragraph>
      <Paragraph center>
        <strong>Vertreten durch:</strong>
        <br />
        Falko Zander
        <br />
        Eckhard M. Jäger
      </Paragraph>

      <ImpressumH3>Kontakt</ImpressumH3>
      <Paragraph center>
        Telefon: <Route href='tel:+4917638618782'>+49 176 386 187 82</Route>
        <br />
        E-Mail: <Route href='mailto:office@systema-berlin.de'>office@systema-berlin.de</Route>
      </Paragraph>

      <ImpressumH3>Angaben zur Berufshaftpflichtversicherung</ImpressumH3>
      <Paragraph center>
        <strong>Name und Sitz des Versicherers:</strong>
        <br />
        AXA Versicherung AG
        <br />
        Colonia-Allee 10-20
        <br />
        51067 Köln
      </Paragraph>
      <Paragraph center>
        <strong>Geltungsraum der Versicherung:</strong>
        <br />
        Deutschland
      </Paragraph>

      <ImpressumH3>Redaktionell verantwortlich</ImpressumH3>
      <Paragraph center>
        Falko Zander
        <br />
        c/o Eckhard Jäger
        <br />
        Berliner Str. 11
        <br />
        13187 Berlin
      </Paragraph>

      <ImpressumH3>EU-Streitschlichtung</ImpressumH3>
      <Paragraph center>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
        <Route href='https://ec.europa.eu/consumers/odr/'>
          https://ec.europa.eu/consumers/odr/
        </Route>
        . Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </Paragraph>

      <ImpressumH3>Verbraucherstreitbeilegung / Universalschlichtungsstelle</ImpressumH3>
      <Paragraph center>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </Paragraph>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(Impressum);
